<template>
  <div>
    <b-row>
      <b-col md="12">
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="10%" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성기간</label>
                      </td>
                      <td width="40%" class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-form-input type="text" name="daterange_popupbanner" />
                          </b-col>
                        </b-row>
                      </td>
                      <td width="10%" style="background-color:#f1f1f1">
                        <label class="col-form-label">이미지 업로드<br/>(500 X 500)</label>
                      </td>
                      <td width="40%" class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="10">
                            <!-- <div :class="imgFileCheck ? 'imgfile' : 'imgfilenone'"><input type="file" class="form-control-file" id="file" ref="file" accept=".jpg, .jpeg, .png" style="padding:5px" v-on:change="handleFileUpload('MAIN_FILE')"/></div> -->
                            <div class="pb-1"><input type="button" value=" 업로드 " style="padding:5px"  v-on:click="formModal=true"/></div>
                            <div><b id="imgnone_popupbanner" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지 또는 HTML코드를 등록해주세요.</b></div>
                            <div><b id="imgnone_popupbanner_img" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지를 등록해주세요.</b></div>
                            <div><b id="imgnone_popupbanner_html" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">HTML코드를 등록해주세요.</b></div>
                          </b-col>
                          <b-col sm="2">
                            <a href="javascript:void(0)" v-on:click="popupBannerPreview()"><u>미리보기</u></a>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">URL</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-form-input id="basicText1" name="landingurl" type="text" v-model="queryParams.landing_url" v-validate="'required'" :class="{'is-invalid': errors.has('landingurl')}"></b-form-input>
                            <span v-show="errors.has('landingurl')" :class="{error: errors.has('landingurl')}">랜딩 URL은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성화</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <c-switch type="text" variant="primary" v-model="queryParams.active_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
      </b-col>
    </b-row>
    <b-modal title="이미지 / HTML 업로드" size="lg" v-model="formModal" @ok="formModal = false"
    no-close-on-backdrop no-close-on-esc hide-footer>
      <div class="">
        <table class="table b-table table-striped">
            <tbody class="">
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="30%" style="background-color:#f1f1f1">
                    <label class="col-form-label">이미지 / HTML</label>
                  </td>
                  <td width="70%" class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="12">
                        <b-form-group>
                          <b-form-radio-group v-model="queryParams.contents_type">
                            <b-form-radio value="1">이미지</b-form-radio>
                            <b-form-radio value="2">html</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </td>
              </tr>
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="30%" style="background-color:#f1f1f1">
                    <label class="col-form-label">업로드 / 코드</label>
                  </td>
                  <td width="70%" class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="12" v-show="queryParams.contents_type=='1'">
                        <div :class="imgFileCheck ? 'imgfile' : 'imgfilenone'"><input type="file" class="form-control-file" id="file" ref="file" accept=".jpg, .jpeg, .png" style="padding:5px" v-on:change="handleFileUpload('MAIN_FILE')"/></div>
                      </b-col>
                      <b-col sm="12" v-show="queryParams.contents_type=='2'">
                          <textarea id="basicText2" rows="15" cols="70" style="border:1px solid #c2cfd6" v-model="queryParams.contents_html"></textarea>
                      </b-col>
                    </b-row>
                  </td>
              </tr>
            </tbody>
        </table>
      </div>

      <hr />

      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-primary" @click="popupSave()">저장</b-button>
        <b-button variant="outline-success" @click="formModal = false">취소</b-button>
      </span>
    </b-modal>
    <!-- /////////////////////////////////////////// -->
    <!-- 팝업 -->
    <section id="popupBanner1" class="popup" style="max-width:500px;max-heigh:500px">
    	<div class="container_pop" v-if="queryParams.contents_type == '1'">
		    <img :src="queryParams.img_url">
      </div>
      <div class="container_pop" v-if="queryParams.contents_type == '2'">
        <p v-html="queryParams.contents_html"></p>
      </div>
    	<div class="hide_pop">
    		<!-- <a v-on:click="closePopupNotToday()">오늘하루 그만보기</a> -->
    		<a v-on:click="hide_pop()">닫기</a>
      </div>
    </section>
    <!-- / -->
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import cSwitch from '../../components/Switch'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    cSwitch
  },
  props: {
    queryParams: {
    },
  },
  data() {
    return {
      // contents_type: '1',
      formModal:false,
      imgFileCheck: true,
      newslettercode: '',
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      ratingOptions: [], // 평가시 적립 포인트 코드 조회 => 평가시 적립 포인트 선택
      ratingPointData: '',
      formtype: '',
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      enabled: true,
    }
  },
  watch: {
  },
  mounted: function() {
    $("#popupBanner1").hide('fade');

    $("#imgnone_popupbanner").hide();
    $("#imgnone_popupbanner_img").hide();
    $("#imgnone_popupbanner_html").hide();
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;

    $(function() {
      $(".imgnone").hide();
      setTimeout(function(){
        $('input[name="daterange_popupbanner"]').daterangepicker({
          opens: 'left',
          "locale": self.calendarLocale,
          "endDate": self.queryParams.end_date,
          "startDate": self.queryParams.start_date
        }, function(start, end, label) {
          self.queryParams.start_date = start.format('YYYY-MM-DD');
          self.queryParams.end_date = end.format('YYYY-MM-DD');
        });
      }, 300);
    });


  },
  methods: {
    hide_pop(){
      $("#popupBanner1").hide('fade');
    },
    popupBannerPreview(){
      console.log('팝업베너 미리보기');
      console.log(this.queryParams.img_url)
      $("#popupBanner1").show('fade');
    },
    popupSave(){
      this.formModal = false;
      console.log(this.queryParams);
      this.validateCheckFN();
    },
    validateCheckFN(){
      var self = this;
      this.$validator.validateAll().then(res=>{
        console.log(res);
        if(res){
            self.queryParams.formValidation = true;
        }else{
            self.queryParams.formValidation = false;
        }

        if(self.queryParams.listThumbnailFile.length == 0 && (self.queryParams.contents_html == '' || self.queryParams.contents_html == null)){

          $("#imgnone_popupbanner").show();
          $("#imgnone_popupbanner_img").hide();
          $("#imgnone_popupbanner_html").hide();
          self.imgFileCheck = false;
          self.queryParams.formValidation = false & self.queryParams.formValidation;
          // queryParams.contents_type
        }else if(self.queryParams.contents_type == '1' && self.queryParams.listThumbnailFile.length == 0){
          $("#imgnone_popupbanner").hide();
          $("#imgnone_popupbanner_img").show();
          $("#imgnone_popupbanner_html").hide();
          self.imgFileCheck = false;
          self.queryParams.formValidation = false & self.queryParams.formValidation;
        }else if(self.queryParams.contents_type == '2' && (self.queryParams.contents_html == '' || self.queryParams.contents_html == null)){
          $("#imgnone_popupbanner").hide();
          $("#imgnone_popupbanner_img").hide();
          $("#imgnone_popupbanner_html").show();
          self.imgFileCheck = false;
          self.queryParams.formValidation = false & self.queryParams.formValidation;
        }else{
          $("#imgnone_popupbanner").hide();
          $("#imgnone_popupbanner_img").hide();
          $("#imgnone_popupbanner_html").hide();
          self.imgFileCheck = true;
          self.queryParams.formValidation = true & self.queryParams.formValidation;
        }
      })
    },
    // 메소드명 : handleFileUpload()
    // ### 단일 파일업로드 ###
    // 한개의 파일 업로드를 진행한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - fileType : 파일 타입
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleFileUpload(fileType){
      var self = this;
      self.queryParams.listThumbnailFile = [];
      var token = sessionStorage.getItem("myToken");
      self.file = self.$refs.file.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'mainbanner');
      formData.append('fileSubPath', 'img');

      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          result.data.file_type_code = fileType;
          self.queryParams.listThumbnailFile.push(result.data);
          self.queryParams.listThumbnailFile.forEach(function (el, idx, arr){
            self.queryParams.img_url = el.file_url;
            self.queryParams.img_width = el.file_width;
            self.queryParams.img_height = el.file_height;
          });
          $("#imgnone_popupbanner").hide();
          $("#imgnone_popupbanner_img").hide();
          $("#imgnone_popupbanner_html").hide();
          self.imgFileCheck = true;
          $("#imgcreat").hide();
          $("#imgdata").show();
          $("#imgdata").attr("src" ,self.queryParams.img_url);
          $("#imgdel").show();
      })

      this.validateCheckFN();
    },
    imgFileDelete(){
      var self = this;
      console.log(self.queryParams);
      console.log(self.queryParams.listThumbnailFile.length);
      self.queryParams.listThumbnailFile = [];
      $("#imgcreat").show();
      $("#imgcreat").css("display", "table-cell");
      $("#imgdata").hide();
      $("#imgdata").attr("src", "");
      $("#imgdel").hide();
      $("#file").val('');
    }

  }
}

</script>
<style media="screen">
div.modal .modal-dialog.modal-1240 {
  width: 1240px !important;
}
</style>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/main/BannerPopUpForm.vue